export { default } from './defaultTheme';
